window.ContactPreferences = (function () {
    window.dataLayer = window.dataLayer || [];
    let self = {
        httpStatusCodes: {
            ok: 200
        },
        elements: {
            radiobutton: {
                emailOnly: '#member-contact-preferences-email-only',
                emailAndPost: '#member-contact-preferences-email-and-print'
            },
            button: {
                submitButton: '#member-contact-preferences-submit'
            },
            notification: {
                communicationPreference: {
                    failureId: '#member-contact-preferences-your-plan-failureId'
                }
            }
        },
        urls: {
            updateContactPreferencesUrl: '/api/sitecore/ContactPreferences/UpdateContactPreferences',
            errorPageUrl: '/error/error-page'
        },
        func: {
            init: function () {
                self.func.bindEvents();
                self.func.hideNotification();
            },
            bindEvents: function () {
                $(self.elements.button.submitButton).on('click', self.func.handleSubmitButtonClick);
            },
            handleSubmitButtonClick: function (event) {
                event.preventDefault();
                const data = {
                    IsEmailOnlySelected: $(self.elements.radiobutton.emailOnly).is(':checked'),
                    IsEmailAndPostSelected: $(self.elements.radiobutton.emailAndPost).is(':checked')
                };
                self.func.updatePreferences(data);
            },
            updatePreferences: function (formData) {
                self.func.hideNotification();
                $.ajax({
                    url: self.urls.updateContactPreferencesUrl,
                    method: 'PATCH',
                    contentType: 'application/json',
                    data: JSON.stringify(formData),
                    success: function (response) {
                        if (response.statusCode === self.httpStatusCodes.ok) {
                            if(response?.preferencesResponse?.communicationPreference?.success){
                                window.snackBar(response.snackBarMessage, true);
                            }else{
                                $(self.elements.notification.communicationPreference.failureId).show();
                            }
                        } else {
                            $(self.elements.notification.communicationPreference.failureId).show();
                        }
                    },
                    error: function () {
                        $(self.elements.notification.communicationPreference.failureId).show();
                    }
                });
            },
            hideNotification: function () {
                $(self.elements.notification.communicationPreference.failureId).hide();
            }
        }
    };

    return {
        Init: self.func.init
    };
})();

$(document).ready(function () {
    if ('contactPreferences' === $('#member-contact-preferences').data('feature')) {
        window.ContactPreferences.Init();
    }
});
